import { ensureSnapshotGitattributes } from './ensure-snapshot-gitattributes.js'
import { ensureSnapshotGitignore } from './ensure-snapshot-gitignore.js'

export function ensureSnapshotGitFiles(cwd: string): void {
  ensureSnapshotGitignore(cwd)
  ensureSnapshotGitattributes(cwd)
}
